import React, { useEffect, useRef, useState } from "react";
import { loadCities, suggestCities } from "./places";

const PinIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 21s-7-6.2-7-11.5A7 7 0 0119 9.5C19 14.8 12 21 12 21z" />
    <circle cx="12" cy="9.5" r="2.5" />
  </svg>
);

/**
 * Eingabefeld mit Städte-Vorschlägen.
 * value: angezeigter Text · onTextChange(text): bei jeder Eingabe · onSelect(place): bei Auswahl eines Vorschlags
 */
const PlaceInput = ({ id, value, placeholder, onTextChange, onSelect }) => {
  const [cities, setCities] = useState([]);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(-1);
  const wrapRef = useRef(null);

  useEffect(() => {
    let alive = true;
    loadCities().then((list) => alive && setCities(list));
    return () => {
      alive = false;
    };
  }, []);

  useEffect(() => {
    const close = (e) => wrapRef.current && !wrapRef.current.contains(e.target) && setOpen(false);
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  const suggestions = open ? suggestCities(cities, value) : [];

  const choose = (place) => {
    onSelect(place);
    setOpen(false);
    setActive(-1);
  };

  const onKeyDown = (e) => {
    if (!suggestions.length) return;
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setActive((i) => (i + 1) % suggestions.length);
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setActive((i) => (i <= 0 ? suggestions.length - 1 : i - 1));
    } else if (e.key === "Enter" && active >= 0) {
      e.preventDefault();
      choose(suggestions[active]);
    } else if (e.key === "Escape") {
      setOpen(false);
    }
  };

  return (
    <div className="ipl-suggest" ref={wrapRef}>
      <div className="ipl-input">
        <PinIcon />
        <input
          id={id}
          type="text"
          autoComplete="off"
          spellCheck="false"
          placeholder={placeholder}
          value={value}
          role="combobox"
          aria-controls={`${id}-list`}
          aria-expanded={suggestions.length > 0 ? "true" : "false"}
          aria-autocomplete="list"
          onChange={(e) => {
            onTextChange(e.target.value);
            setOpen(true);
            setActive(-1);
          }}
          onFocus={() => setOpen(true)}
          onKeyDown={onKeyDown}
        />
      </div>
      {suggestions.length > 0 && (
        <ul role="listbox" id={`${id}-list`}>
          {suggestions.map((s, i) => (
            <li
              key={`${s.label}-${s.lat}`}
              role="option"
              aria-selected={i === active}
              onMouseDown={(e) => {
                e.preventDefault();
                choose(s);
              }}
            >
              <strong>{s.label}</strong>
              {s.detail && <span className="ipl-suggest-detail">{s.detail}</span>}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default PlaceInput;
